import { render, staticRenderFns } from "./AdminScriptLayout.vue?vue&type=template&id=5844a82d&scoped=true"
import script from "./AdminScriptLayout.vue?vue&type=script&lang=js"
export * from "./AdminScriptLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminScriptLayout.vue?vue&type=style&index=0&id=5844a82d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844a82d",
  null
  
)

export default component.exports